"use client";

/**
 * Client wrapper that dynamically imports the heavy desktop Features variant
 * and only mounts it when the viewport matches `(min-width: 1024px)`. Mobile
 * visitors never download the motion `AnimatePresence`/`popLayout` runtime
 * or `PixelEffect` referenced by the desktop component.
 *
 * A reserved-height placeholder is rendered at `lg+` while the dynamic chunk
 * is in flight to avoid layout shift when the desktop variant mounts.
 */

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

const HomeFeaturesDesktopDynamic = dynamic(
  () => import("@/components/HomeFeaturesDesktop"),
  {
    ssr: false,
    loading: () => (
      <div
        aria-hidden
        className="hidden lg:block h-[660px]"
      />
    ),
  }
);

export default function HomeFeaturesDesktopLazy({
  features,
}: {
  features: any;
}) {
  const [shouldMount, setShouldMount] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia("(min-width: 1024px)");
    const update = () => setShouldMount(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  if (!shouldMount) return null;
  return <HomeFeaturesDesktopDynamic features={features} />;
}
